export default __webpack_public_path__ + "static/media/char_broiler_02.7d944f4e.png";